/**
 * A project's name, and the one rule everything that stores one agrees on: the
 * app's store, the project document's parser, and the account area's editor.
 *
 * It is a label people read, so almost anything goes — spaces, accents, a
 * leading dot. But the desktop app also makes a folder of it: the clone in a
 * session's workdir and the bundles that carry it (§5.4), which under a
 * worktree placement are folders *on the host*, removed whole at every seed.
 * A name that is a path — `../..`, `a/b`, `C:\x` — or that holds a control
 * character is therefore refused wherever a name comes in, and a document
 * carrying one is refused with it: `repos[].name` comes from whoever published
 * the organization's project, not from the person who opens it.
 */
// eslint-disable-next-line no-control-regex -- control characters are exactly what is refused.
const UNSAFE = /[/\\\x00-\x1f\x7f]/;

/** Why `name` (already trimmed) cannot name a project, or `null` when it can. */
export function projectNameProblem(name: string): string | null {
  if (!name) return 'A name is required.';
  if (name === '.' || name === '..') return 'A name cannot be “.” or “..”.';
  if (UNSAFE.test(name)) return 'A name cannot hold a slash, a backslash or a control character.';
  return null;
}

export function validProjectName(name: string): boolean {
  return projectNameProblem(name) === null;
}
